import "./style.css"

function ConfirmDelete({ title, itemName, setToDelete, _delete }) {

    return (
        <div className="confirm_delete">
            <div className="content">
                <span>{title}</span>
                <p>
                    Vous vous apprêtez à supprimer "{itemName}".
                    <br />
                    Êtes-vous sûr ?
                </p>

                <div className="panel">
                    <button onClick={() => setToDelete(null)}>Non</button>
                    <button className="btn_red" onClick={() => _delete()}>Oui</button>
                </div>
            </div>
        </div>
    )
}

export default ConfirmDelete;